"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'compLayout'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps, compLayout = _a.compLayout;
    var sizeLimits = {
        compact: { minW: 250, minH: 80 },
        large: { minW: 250, minH: 330 },
    };
    var iframeSrc = null;
    var width = compLayout.width || 0;
    var height = sizeLimits[compProps.size].minH;
    if (compProps.size === 'large') {
        height += width - sizeLimits[compProps.size].minW;
    }
    var uri = compData.uri;
    var color = compProps.color, style = compProps.style;
    if (uri !== '') {
        iframeSrc = "https://embed.spotify.com/?" + new URLSearchParams({
            uri: uri,
            color: color,
            style: style,
        });
    }
    return { iframeSrc: iframeSrc, width: width, height: height };
});
exports.css = withCompInfo_1.withCompInfo(['compData'], function (_a) {
    var compData = _a.compData;
    var placeholderDisplay = 'none';
    if (compData.uri === '') {
        placeholderDisplay = 'block';
    }
    return {
        '--placeholder-display': placeholderDisplay,
    };
});
//# sourceMappingURL=SpotifyPlayer.js.map